import { monitoringNavigationLoader } from './loaders/monitoring-navigation.loader';
import { PermissionsGuard } from '../../../../store/guards/permissions.guard';
import { accountNavigationLoader } from './loaders/account-navigation.loader';
import type { HeaderNavigation } from './header-navigation.types';
import { Permission } from '../../../constants/permissions';

export * from './header-navigation.types';

export const headerNavigation: HeaderNavigation = [
  {
    pathname: '/billing',
    label: 'Billing',
    ariaLabel: 'Navigate to billing',
    activators: [PermissionsGuard({ every: [Permission.BILLING_READ] })],
  },
  {
    alias: 'IQ',
    label: 'IQ Analytics',
    ariaLabel: 'IQ Analytics group',
    activators: [
      PermissionsGuard({
        every: [Permission.NITEL_IQ_PARTICIPANT],
      }),
    ],
    children: [
      {
        pathname: '/analytics/historical-observations',
        label: 'Historical Observations',
        ariaLabel: 'Navigate to historical observations',
      },
      {
        pathname: '/analytics/metric-details',
        label: 'Metric Details',
        ariaLabel: 'Navigate to metric details',
      },
      {
        pathname: '/analytics/quality-of-experience',
        label: 'Quality of Experience',
        ariaLabel: 'Navigate to quality of experience',
      },
      {
        pathname: '/analytics/unusual-network-metrics',
        label: 'Unusual Network Metrics',
        ariaLabel: 'Navigate to unusual network metrics',
      },
    ],
  },
  monitoringNavigationLoader,
  {
    pathname: '/orders',
    label: 'Orders',
    ariaLabel: 'Navigate to orders',
    activators: [PermissionsGuard({ every: [Permission.ORDERS] })],
  },
  {
    label: 'Reports',
    ariaLabel: 'Reports group',
    children: [
      {
        pathname: '/reports/operations-summary',
        label: 'Operations Summary',
        ariaLabel: 'Navigate to operations summary',
        activators: [
          PermissionsGuard({
            every: [
              Permission.TICKETING_READ,
              Permission.SERVICES,
              Permission.ORDERS,
            ],
          }),
        ],
      },
      {
        pathname: '/reports/orders-summary',
        label: 'Orders Summary',
        ariaLabel: 'Navigate to orders summary',
        activators: [PermissionsGuard({ every: [Permission.ORDERS] })],
      },
    ],
  },
  {
    pathname: '/services',
    label: 'Services',
    params: { groupBy: 'Location' },
    ariaLabel: 'Navigate to services',
    activators: [PermissionsGuard({ every: [Permission.SERVICES] })],
  },
  {
    pathname: '/tickets',
    label: 'Tickets',
    params: { groupBy: 'Type' },
    ariaLabel: 'Navigate to tickets',
    activators: [PermissionsGuard({ every: [Permission.TICKETING_READ] })],
  },
  accountNavigationLoader,
];
